import { Button, Card, DateRangePicker, Divider } from '@features/ui';
import { useEffect, useState } from 'react';
import { DateValueType } from '@lib/utils.ts';
import { getChurnByDate } from '@src/services/reports.ts';
import { TReportBlacklistUsersParams, TReportChurnByDate } from '@src/types';

export const ChurnRateByDate = () => {
  const [valueStart, setValueStart] = useState<DateValueType>(null);
  const [valueEnd, setValueEnd] = useState<DateValueType>(null);
  const [data, setData] = useState<TReportChurnByDate | null>(null);

  const fetchChurnByDate = async (params?: TReportBlacklistUsersParams) => {
    const res = await getChurnByDate(params);

    setData(res);
  };

  useEffect(() => {
    fetchChurnByDate().then();
  }, []);

  const handleGetData = async () => {
    await fetchChurnByDate({
      start_date: valueStart?.startDate?.toISOString(),
      end_date: valueEnd?.startDate?.toISOString(),
    });
  };

  return (
    <div>
      <div className={'flex flex-col gap-7.5'}>
        <h1 className={'text-[23px]'}>{`Users - Churn Rate by Date`}</h1>
      </div>
      <Card className={'mt-4.5'}>
        <div
          className={
            'flex justify-between items-start lg:flex-row flex-col mb-5 gap-6'
          }
        >
          <div className={'w-full flex gap-6 flex-wrap'}>
            <DateRangePicker
              asSingle={true}
              className={'max-w-[239px]'}
              placeholder={'Created From'}
              size={'sm'}
              value={valueStart}
              variant={'outline'}
              onChange={setValueStart}
            />
            <DateRangePicker
              asSingle={true}
              className={'max-w-[239px]'}
              placeholder={'Created To'}
              size={'sm'}
              value={valueEnd}
              variant={'outline'}
              onChange={setValueEnd}
            />
          </div>
          <div className={'flex gap-5'}>
            <Button size={'sm'} variant={'lime'} onClick={handleGetData}>
              Get
            </Button>
          </div>
        </div>
        <Divider />
        <div className={'flex flex-col gap-1 mt-7'}>
          <p className={'font-bold text-sm'}>
            Total Users: {data?.total_users ?? 0}
          </p>
          <p
            className={'text-xs mt-2'}
          >{`Active: ${data?.active ?? 0} (${data?.active_percent ?? ''})`}</p>
          <p
            className={'text-xs'}
          >{`Expired: ${data?.expired ?? 0} (${data?.expired_percent ?? ''})`}</p>
        </div>
      </Card>
    </div>
  );
};
